import { Image } from "@chakra-ui/react";
import logo from "../../assets/logos/PNG/logo_horizontal_verde_branco2.png";

export function Logo() {
  
  return (
    <Image 
      src={logo}
      boxSize={["0", "120"]}
      objectFit="contain"
    />
  );
}
